import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { SPRACompetitionCsaRate, SPRACompetitionDetailParams } from 'src/app/Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { SpraCompetitionCsaRateComponent } from '../spra-competition-csa-rate/spra-competition-csa-rate.component';

@Component({
  selector: 'app-spra-competition-detail',
  templateUrl: './spra-competition-detail.component.html',
  styleUrls: ['./spra-competition-detail.component.css']
})
export class SpraCompetitionDetailComponent implements OnInit {
  private utility: Utility;
  public SPRACompetitionDetailArray: Array<SPRACompetitionDetailParams> = [];
  public Mode: string;                      // "I" New Insertion, "U" Update, "V" validation
  public IsRental:boolean = false;
  public IsCopetitionCsaRateRequired: boolean;
  public SPRACompCSARateUpdate: Array<SPRACompetitionCsaRate>=[];
 
  constructor(
    private dialog: MatDialog
    , private cookieService: CookieService
    , private _NotificationService: NotificationService
  ) {
    this.Mode = "I";
    this.SPRACompetitionDetailArray = new Array<SPRACompetitionDetailParams>();
    this.SPRACompetitionDetailArray.push(new SPRACompetitionDetailParams());
    this.IsCopetitionCsaRateRequired = false;
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {

  }


  ComptModelChange(_SPRACompetitionDetailParams: SPRACompetitionDetailParams, index: number) {
    // && this.Mode == "I"
    if ((index + 1) == this.SPRACompetitionDetailArray.length) {
      this.addRow(_SPRACompetitionDetailParams);
    }
  }


  addRow(CompetitionDetail: SPRACompetitionDetailParams) {
    CompetitionDetail.IsNewRow = true;
    this.SPRACompetitionDetailArray.push(new SPRACompetitionDetailParams());
    return true;
  }



  deleteRow(index: number) {
    if (this.SPRACompetitionDetailArray.length == 1) {
      return false;
    } else {
      this.SPRACompetitionDetailArray.splice(index, 1);
      return true;
    }
  }



  EnterCsaRate(_competitionDetail: SPRACompetitionDetailParams): void {

   
    const dialogRef = this.dialog.open(SpraCompetitionCsaRateComponent, {
      width: '80%',
      data: _competitionDetail.CsaRate
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        _competitionDetail.CsaRate = new Array<SPRACompetitionCsaRate>();
        _competitionDetail.CsaRate = result.data;
      }
    });
  }



  Validation(): boolean {


    if (this.SPRACompetitionDetailArray.filter((cs) => {
      return this.utility.CheckStringRequired(cs.CompName)
        || this.utility.CheckStringRequired(cs.CompModel)
        || this.utility.CheckNumberRequired(cs.CompPrice)
    }).length <= 0) {
      this._NotificationService.showError("Please enter at least one competition detail.", "Competition");
      return false;
    }



    // let IsCompValid: boolean = true;
    let i: number;
    for (i = 0; i < this.SPRACompetitionDetailArray.length; i++) {
      let  OrdinalSuffixOfIndex :string  = this.utility.Ordinal_suffix_of(i+1);
      if ((this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompName)
            || this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompModel)
            || this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompPrice)
            || this.utility.CheckNumberRequired(this.SPRACompetitionDetailArray[i].CompPrice)
          )
        &&
        (!this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompName)
          || !this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompModel)
          || !this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompPrice)
          || !this.utility.CheckNumberRequired(this.SPRACompetitionDetailArray[i].CompPrice)
        )) 
      {       
        if (!this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompName)) {
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition name.", "Competition");
          return false;
        }
        else if (!this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompModel)) {
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition model.", "Competition");
          return false;
        }
        else if (!this.IsRental && !this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompPrice)) {
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition price.", "Competition");
          return false;
        }
        //Added By rahul yadav on 26/05/2021
          else if (!this.IsRental && !this.utility.CheckNumberRequired(this.SPRACompetitionDetailArray[i].CompPrice)) {
            this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition price value greater than 0.", "Competition");
            return false;
        
        }
        else if (this.IsRental &&!this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].Tenure)) {
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition tenure.", "Competition");
          return false;
        }else if (this.IsRental && !this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].Rent)) {
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition rent.", "Competition");
          return false;
        }

      else if(this.IsCopetitionCsaRateRequired
          &&
            ( this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompName)
              && this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompModel)
              && 
              (
                (this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].CompPrice) && !this.IsRental)
                ||
                ((this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].Tenure) && this.IsRental)
                &&
                (this.utility.CheckStringRequired(this.SPRACompetitionDetailArray[i].Rent) && this.IsRental))

              )
            )
          &&
            this.SPRACompetitionDetailArray[i].CsaRate?.filter(cr=>{
              return cr.Rate != undefined && cr.Rate>0
            }) == undefined
        ){
          this._NotificationService.showError("Please enter "+ OrdinalSuffixOfIndex +" competition CSA Rate .", "Competition");
          return false;
      }
    }



    }


    return true;
    // return IsCompValid;


  }




  ResetCompCsaRate(){
    this.SPRACompetitionDetailArray.forEach((item:SPRACompetitionDetailParams) =>{
      item.CsaRate = undefined;
    });
  }

}
